import throttle from "lodash/throttle";

/**
 * The default throttle used for button clicks that fire API calls
 * This ensures that the call is made right away, and any subsequent calls
 * for [timeout]ms are ignored and never run.
 *
 * See this Medium article for a description of the leading/trailing options and how they affect the timing of calls:
 * https://ellenaua.medium.com/throttle-debounce-behavior-lodash-6bcae1494e03
 *
 * @param func
 * @param timeout
 * @param options
 */
export const dreamThrottle: typeof throttle = (func, timeout = 2000, options) =>
  throttle(func, timeout, {
    leading: true,
    trailing: false,
    ...options,
  });
